import React from "react";
import { message } from "antd";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import "../../Styles/Components.less";
import PropTypes from "prop-types";
import MainPage from "../MainPage";
import ListDeviceModel from "./ListDeviceModel";
import DeviceModelForm from "./DeviceModelForm";
import ModelDependency from "./ModelDependency";
import ServiceTier from "../ServiceTier/ServiceTier";
import { apiCallback, statusChangeApiCallback } from "../../ApiHandlers/Common";
import {
  DeviceModelActions,
  EntityStatus,
  NavMenuItems,
} from "../../Constants/Constants";
import { convertDeviceModelList } from "../../Helpers/DeviceModelHelpers";
import ListDevices from "../Device/ListDevices";

class DeviceModel extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.deviceModel.icon()}
        <span>{NavMenuItems.deviceModel.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      deviceModelData: [],
      deviceModelDataLoading: false,
    };
  }

  componentDidMount() {
    this.fetchDeviceModelList();
  }

  fetchDeviceModelList() {
    const { history, deviceModelApi } = this.props;
    this.setState({ deviceModelDataLoading: true });
    const errorCallback = () => {
      this.setState({ deviceModelDataLoading: false });
      message.error("Error fetching Device Model list");
    };
    const successCallback = (data) => {
      const deviceModelData = convertDeviceModelList(data);
      console.log("updateList data", deviceModelData);
      this.setState({ deviceModelData, deviceModelDataLoading: false });
    };
    try {
      deviceModelApi.getDeviceModels(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  }

  onActionClick = (action, record) => (e) => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.fetchDeviceModelList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      const { deviceModelApi } = this.props;
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.modelNumber,
        errorRollback: () => this.changeStatus(record.modelId, !status),
      });
      if (status) {
        deviceModelApi.activateDeviceModel(record.modelId, callback);
      } else {
        deviceModelApi.inActivateDeviceModel(record.modelId, callback);
      }
      this.changeStatus(record.modelId, status);
    } catch (error) {
      message.error(`Error changing status of ${record.modelNumber}`);
    }
  };

  changeStatus = (itemId, status) => {
    const deviceModelData = [...(this.state?.deviceModelData || [])];
    deviceModelData.forEach((item) => {
      if (item.modelId === itemId) {
        item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
      }
    });
    this.setState({ deviceModelData });
  };

  render() {
    const { action, record, deviceModelData, deviceModelDataLoading } =
      this.state;
    return (
      <MainPage>
        <div className="device-model-container">
          {!action ? (
            <ListDeviceModel
              deviceModelData={deviceModelData}
              deviceModelDataLoading={deviceModelDataLoading}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              parentBread={this.header}
            />
          ) : action === DeviceModelActions.dependency ? (
            <ModelDependency
              record={record}
              deviceModelData={deviceModelData}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : action === DeviceModelActions.listDevice ? (
            <ListDevices
              deviceModelRecord={record}
              parentBread={this.header}
              onParentActionClick={this.onActionClick}
            />
          ) : action === DeviceModelActions.listTier ? (
            <ServiceTier
              deviceModelRecord={record}
              onParentActionClick={this.onActionClick}
              parentBread={this.header}
            />
          ) : (
            <DeviceModelForm
              action={action}
              record={record}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

DeviceModel.propTypes = {
  parentBread: PropTypes.array,

  deviceModelApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  deviceModelApi: state.apis.deviceModelApi,
});
const connectedDeviceModel = connect(mapStateToProps)(DeviceModel);
export default withRouter(connectedDeviceModel);
